module.exports = __webpack_public_path__ + "static/img/Lohmann.3b51359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lohmann.jpg
// module id = n/49
// module chunks = 0